import { Markdown } from 'common/markdown-components';
import styles from './styles.module.css';

const markdownContent = `
## How Does Our Casino Complaint Service Work?
![Uploaded Image](https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745958696143-612199461-image.webp_resize_fullx400)

Our casino complaint service provides a platform for players experiencing issues with online casinos. If a casino refuses to pay out your winnings, has account verification delays, or mishandles your deposit, here's how we can help:


• Submit a Complaint: Share the details of your issue through our platform. Be as specific as possible to help us understand the problem.
• Investigation: We review your complaint and contact the casino for clarification.
• Blacklist Action: If the casino fails to resolve the issue or provide evidence that the player violated terms, we add it to our blacklist.
• Problem Resolution: Most reputable casinos prefer to resolve issues promptly, and players often see positive outcomes after our intervention.

Our goal is to promote fairness and accountability in online gambling while protecting players.

## Service Rules
![Uploaded Image](https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745958719258-962288565-image.webp_resize_fullx400)

To maintain the integrity of our complaint service, we operate under strict guidelines:

**No Assistance for Rule Violations:**
If you were caught multi-accounting or engaging in fraudulent activities, we cannot help.
Violations of bonus terms and conditions, such as abusing promotions, disqualify you from our service.

**Evidence Required:**
Players must provide clear evidence of their claims, such as screenshots, email correspondence, or transaction records.

**Honesty is Essential:**
False claims or withholding relevant information will lead to immediate disqualification from our assistance.

**Timeliness Matters:**
Submit your complaint within a reasonable timeframe to ensure effective resolution.
`;

export const ComplaintsDescription = () => {
  return (
    <div className={styles.container}>
      <Markdown data={markdownContent} />
    </div>
  );
};
